<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
        :is_show_chart_dialog="is_show_chart_dialog"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #signs
            v-if="default_value == 91"
        >
            <MonitorSigns 
                :data="sign_data" 
                sort_type="city_case"
                :is_show_raw_html="true"
                :hide_alert_remarks="true"
            />
        </template>

        <template #filter_condition_options
            v-if="default_value == 91"
        >
            <MonitorOptionSet 
                ref="monitor_option_set"
                :option_set="option_set"
                @filter_data="filter_data"
            />
        </template>

        <template #description>
            <div v-if="default_value == 329" class="align-center-items">
                <span class="description-dot" style="background: #FF0000"/> (50dBZ超過4格網格後示警)​
            </div>
        </template>
        
        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :search="slot_props.search"
                :should_draw_diagram_header="should_draw_diagram_header"
                :enable_diagram_slot="true"
                :should_display_info_header_key_value="should_display_info_header_key_value"
                :generate_tooltop_display_info="generate_tooltop_display_info_for_table"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
                @open-chart="assign_chart_component"
                :is_show_chart_dialog_parent.sync="is_show_chart_dialog"
            >
                <template #diagram_dialog="{ close_dialog }">
                    <GisChart v-if="is_show_chart_dialog"
                        id="belongs_monitor_chart"
                        :chart_options="chart_options"
                        :default_variable="$t('__rainfall.rainfall')"
                        :prop_rain_selected="current_table_header"
                        @close-chart-dialog="close_dialog"
                    />
                </template>
                <template #table_description>
                    <div v-if="default_value == 332">
                        <span>
                            監測範圍：<br>
                            馬太鞍溪堰塞湖(23.69256°N , 121.30594°E)直徑15公里，共計156格點<br>
                            馬太鞍溪中游(23.691992°N , 121.363103°E)直徑5公里，共計17格點<br>
                            馬太鞍溪橋(23.68871°N , 121.40896°E)直徑3公里，共計7格點<br>
                        </span>
                        <br>
                        <span>
                            警戒標準：<br>
                            預警(黃) <span class="description-dot" style="background: #ffff00;"></span>：各監測範圍出現雷達回波訊號，且強度達30dBZ，回波值所占的面積達60%，持續時間10分鐘，進行預警。<br>
                            警戒(橙) <span class="description-dot" style="background: #eda12f;"></span>：各監測範圍雷達回波訊號增強至40dBZ，回波值所占的面積達60%，持續時間10分鐘，進行警戒。<br>
                            行動(紅) <span class="description-dot" style="background: #f00;"></span>：各監測範圍雷達回波訊號增強至50dBZ，回波值所占的面積達60%，持續時間10分鐘，進行行動。<br>
                        </span>
                    </div>
                    <div v-else >
                        <span>1. 10分鐘、1小時、...、24小時為雷達定量降水估計QPE。</span><br>
                        <span>2. 採用依據參考雨量站之雨量計算而得的有效雨量做為警示值。</span>
                    </div>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>


<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { sort_table_data, sort_callback_by_city_name_tw } from "@/utils/monitor/common_tool.js"
    import {
        generate_variable_options,
        combine_new_variable_options,
        update_option_set_from_local_storage,
        update_current_option_value,
    } from '@/utils/monitor/option.js'
    import { get_stations_history_params } from "@/utils/chart/chart_ajax.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { monitor_signs_normal_mapping, TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import { mapState } from "vuex"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorSigns from "@/components/monitor/_tool/monitor_signs.vue"
    import MonitorOptionSet from "@/components/monitor/monitor_option_set.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue"

    export default {
        name: 'Landslide',

        mixins: [monitor_mixin],
        props: {
            default_value: {
                type: Number,
                required: true,
            }
        },

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorSigns, 
            MonitorOptionSet, 
            QpeDatatable, 
            GisChart: () => import('@/components/chart/gis_chart.vue')
        },

        data() {
            return {
                header: [],
                table_data: [],
                error_text: '',

                // filter使用
                immutable_table_data: [],
                option_set: [],
                display_all_city: '所有縣市',
                display_all_township: '所有鄉鎮',

                should_draw_diagram_header: ['10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '48小時', '72小時'],
                should_display_info_header_key_value: {
                    '警示理由': {},
                },

                is_show_chart_dialog: false,
                chart_options: {
                    type: { 'gauge': true }
                },
                current_table_header: '',

                should_show_raw_html_header: ['警示', '10分前', '20分前', '30分前', '40分前', '50分前'],

                local_storage_option_name: 'landslide_swcb_option',

                search: '',
            }
        },
        
        computed: {
            ...mapState([
                'client_name',
            ]),

            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },

            sign_data() {
                return this.table_data.map(item => {
                    //取第一個燈號放在表頭
                    const is_alert = Array.isArray(item['警示']) && item['警示'].length > 0 && item['警示'][0]['html']
                    const each_sign_data = {
                        idx: item['縣市'],
                        signs_num: is_alert ? item['警示'][0]['html'] : '-'
                    }
                    return each_sign_data
                });
            }
        },
        
        watch: {
            immutable_table_data() {
                if (this.immutable_table_data) {
                    this.generate_option_set()
                    this.option_set = update_option_set_from_local_storage(this.option_set , this.local_storage_option_name)
                }
            },
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data.sort(sort_callback_by_city_name_tw);
                this.header = header;
                
                const sorted_data = sort_table_data(data, monitor_signs_normal_mapping)
                this.table_data = this.reconstruct_alert_content(sorted_data, this.should_show_raw_html_header);
            },

            reconstruct_alert_content(table_contents, be_reconstructed_content) {
                const new_alert_content = table_contents.map(content => {
                    const new_content = be_reconstructed_content.reduce((accumulator, html_header) => {
                        //判定給什麼燈: 紅燈|橘燈|黃燈|空值(沒有)
                        const is_alert = content[html_header]
                        if(!is_alert) return accumulator 
                        if(is_alert === '紅燈') 
                            return {
                                ...accumulator,
                                [html_header]: [{
                                    'html': `<span class="dot" style="background: #f00"/>`,
                                }]
                            }
                        if(is_alert === '橘燈') 
                            return {
                                ...accumulator,
                                [html_header]: [{
                                    'html': `<span class="dot" style="background: #eda12f"/>`,
                                }]
                            }
                        if(is_alert === '黃燈') 
                            return {
                                ...accumulator,
                                [html_header]: [{
                                    'html': `<span class="dot" style="background: #ffff00"/>`,
                                }]
                            }
                    }, {})

                    return { ...content, ...new_content }
                })

                return new_alert_content
            },

            generate_option_set() {
                const basic_variable_options = [
                    { default_value: this.display_all_city, json_key: '縣市', label: 'city' },
                    { default_value: this.display_all_township, json_key: '鄉鎮', label: 'township' },
                ]

                const variable_options = generate_variable_options(basic_variable_options, this.immutable_table_data)
                
                if (this.option_set.length === 0) {
                    this.option_set = [...variable_options]
                } else {
                    this.option_set = combine_new_variable_options(this.option_set, variable_options)
                    this.$refs.monitor_option_set.change_option_set()
                }
            },

            filter_data(filtered_condition, change_condition_label) {
                const update_current_value_by_filtered_condition = update_current_option_value(filtered_condition)
                this.option_set = this.option_set.map(update_current_value_by_filtered_condition)

                if (change_condition_label === 'city') {
                    this.option_set[1].current_option_value = this.display_all_township
                    filtered_condition['township'] = this.display_all_township
                }

                const compare_city = filtered_condition['city'] === this.display_all_city ? '' : filtered_condition['city']
                const compare_township = filtered_condition['township'] === this.display_all_township ? '' :  filtered_condition['township']
        
                const filtered_data = this.immutable_table_data.filter(item => {
                    // 原始資料 雨量 mm 顯示 -- 處理方式為改為 0 後做比較，建立新變數以避免改到原值
                    return (
                        item['縣市'].includes(compare_city) &&
                        item['鄉鎮區'].includes(compare_township)
                    )
                })
                const sorted_data = sort_table_data(filtered_data, monitor_signs_normal_mapping)
                this.table_data = this.reconstruct_alert_content(sorted_data, this.should_show_raw_html_header);

                this.generate_township_option(filtered_condition['city'])
                
                localStorage.setItem(this.local_storage_option_name, JSON.stringify(filtered_condition))
            },

            generate_township_option(city) {
                const filter_towns_by_city = item => item['縣市'] ===  city
                const get_town = item => item['鄉鎮區']
                const filtered_towns_options = city === this.display_all_city ? this.immutable_table_data : this.immutable_table_data.filter(filter_towns_by_city)
                const towns_options = filtered_towns_options.map(get_town)
                this.option_set[1].option_array = [this.display_all_township, ...new Set(towns_options)]
            },
            
            generate_tooltop_display_info_for_table(row) {
                return row['警示條件']
            },

            assign_chart_component(header_name, choosed_value, current_row_data) {
                this.current_table_header = header_name
                this.chart_options = { ...this.chart_options, ...get_stations_history_params.call(this, current_row_data) }
            },    
        },
    }
</script>

<style scoped>
    .option-description {
        margin-left: 10px;
        padding: 5px 10px;
        border: thin solid #cf0;
    }
    .align-center-items{
        display: flex;
        align-items: center;
        gap: 0.25rem;
    }
</style>